import React, { FunctionComponent } from 'react'
import { DocumentOutlineSection, H } from 'react-document-section'
import GatsbyImage from 'gatsby-image'

import {
  UnderlineCalloutHeader,
  UnderlineColors,
} from 'components/UnderlineText'
import { Container, Row, Col } from 'components/grid'
import CompactUniqueSellingPoint, {
  CompactUniqueSellingPointQueryType,
} from 'components/uniqueSellingPoint/CompactUniqueSellingPoint'
import { PrimaryButtonLink } from 'components/Buttons'
import Carousel from 'components/carousel'

import {
  sectionBg,
  contentCol,
  title as titleStyle,
  uspSectionList,
  ctaContainer,
  sectionImageContainer,
  sectionImage,
  carousel,
} from './index.module.scss'

interface USPsWithCarouselProps {
  title: string
  underlineColor: UnderlineColors
  uspList: CompactUniqueSellingPointQueryType[]
  carouselImages: EF.FluidImageNode[]
  ctaText?: string
  ctaPath?: string
}

const USPsWithCarousel: FunctionComponent<USPsWithCarouselProps> = ({
  title,
  underlineColor,
  uspList,
  ctaText,
  ctaPath,
  carouselImages,
}) => {
  return (
    <section className={sectionBg}>
      <DocumentOutlineSection
        title={<UnderlineCalloutHeader text={title} color={underlineColor} />}
      >
        <Container>
          <Row>
            <Col xs={12} lg={6} className={contentCol}>
              <H className={titleStyle} />
              <div className={uspSectionList}>
                {uspList.map(({ title, icon, description }) => (
                  <CompactUniqueSellingPoint
                    key={title}
                    title={title}
                    icon={icon.fields.asset}
                    description={description}
                  />
                ))}
              </div>
              {ctaText && ctaPath && (
                <Container className={ctaContainer}>
                  <Row center="xs" start="lg">
                    <Col lgOffset={2}>
                      <PrimaryButtonLink text={ctaText} path={ctaPath} />
                    </Col>
                  </Row>
                </Container>
              )}
            </Col>
            <Col xs={12} lg={6}>
              <div className={sectionImageContainer}>
                <Carousel
                  className={carousel}
                  keyPrefix="dlp"
                  hanger="0%"
                  anchor="0%"
                  movingStep={1}
                  showButtons
                  isFluid
                >
                  {carouselImages.map(({ fields: { asset } }, index) => (
                    <GatsbyImage
                      className={sectionImage}
                      fluid={asset.fluid}
                      key={`${asset.id}-${index}`}
                      alt={asset.description || asset.title || ''}
                    />
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </DocumentOutlineSection>
    </section>
  )
}

export default USPsWithCarousel
